/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelWebMenuGroup.ts                  *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "common/web-menu-group";

export class AutogenModelWebMenuGroup<RowType extends ModelRow> extends Endpoint<RowType, RowWebMenuGroupFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowWebMenuGroup extends ModelRow<RowWebMenuGroupFields> {
	constructor(values?: Partial<RowWebMenuGroupFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowWebMenuGroupFields {
	company_id: string;
	group_type: string;
	id: string;
	include_group_id: string;
	item_id: string;
	item_position: number;
	parent_id: string;
}
